import _ from 'lodash'

const integratedSistems = [
  { label: 'APP Sistemas', systemId: 'appsis' },
  { label: 'App sis cloud', systemId: 'appcloud' },
  { label: 'B2B RESERVAS', systemId: 'b2b' },
  { label: 'B2b hotel', systemId: 'b2bhotel' },
  { label: 'BeBooking', systemId: 'bebook' },
  { label: 'Benner', systemId: 'benner' },
  { label: 'Bitz software', systemId: 'bitzsoft' },
  { label: 'Check-in', systemId: 'checkin' },
  { label: 'Cmnet', systemId: 'cmnet' },
  { label: 'Conceptprime', systemId: 'conprime' },
  { label: 'Desbravador', systemId: 'desbrava' },
  { label: 'Desbravador 2.0', systemId: 'desbrav2' },
  { label: 'Dhisco', systemId: 'dhisco' },
  { label: 'Engenho', systemId: 'engenho' },
  { label: 'Esolution Tecnologia', systemId: 'esoltech' },
  { label: 'Expedia', systemId: 'expedia' },
  { label: 'Foco', systemId: 'soufoco' },
  { label: 'Foco Multimidia', systemId: 'focomult' },
  { label: 'Gntec', systemId: 'gntec' },
  { label: 'Hmax', systemId: 'hmax' },
  { label: 'Host Hotel System', systemId: 'hoshosys' },
  { label: 'Hotel link', systemId: 'hotellin' },
  { label: 'Htl Teste', systemId: 'htteste' },
  { label: 'Integra PMS', systemId: 'integpms' },
  { label: 'New Hotel - Checkin', systemId: 'nhcheck' },
  { label: 'Newhotel', systemId: 'newhotel' },
  { label: 'Oracle', systemId: 'oracle' },
  { label: 'Pcsystem', systemId: 'pcsystem' },
  { label: 'Port louis pricing', systemId: 'portlp' },
  { label: 'Rmview', systemId: 'rmview' },
  { label: 'Silbeck', systemId: 'silbeck' },
  { label: 'Sistemaio', systemId: 'sistaio' },
  { label: 'Higs', systemId: 'totvs' },
  { label: 'Trend', systemId: 'trend' },
  { label: 'Windsor PMS', systemId: 'windsor' },
  { label: 'Opera', systemId: 'opera' },
  { label: 'Artax', systemId: 'artax' },
]

export function labelSystemIdentity(systemId: string): string | undefined {
  if (!systemId) {
    throw new Error('SystemId is required')
  }

  const find = _.find(
    integratedSistems,
    iSystem => iSystem.systemId === systemId,
  )

  return find ? find.label.toUpperCase() : systemId
}
